import React from 'react';
import { R2pGSlider } from './slider';
import styles from './slider-ja_1.css';

export const R2pSlider = _ => <R2pGSlider {..._} styles={styles} />